import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";

import { routes } from "config/routes";
import { Page } from "shared/components/Page";
import { NavigationHeader } from "ui/NavigationHeader/NavigationHeader";

import { NewBatteryRegistration } from "../components";

export function BatteryCreatePage() {
  const intl = useIntl();
  const navigate = useNavigate();

  const { serialNumber } = useParams<{ serialNumber: string }>();

  if (!serialNumber) {
    navigate(routes.inventory.batteryManagement.root);
    return null;
  }

  return (
    <Page isCentered isFull isBgGrey justifyContent="flex-start">
      <NavigationHeader
        title={intl.formatMessage({ id: "pages.inventory.battery-create-page.title" })}
        onClickGoBack={() => navigate(-1)}
      />

      <NewBatteryRegistration serialNumber={serialNumber} />
    </Page>
  );
}
